module.exports = __webpack_public_path__ + "img/组 6992@2x.53b8d794.png";